import React from 'react';
import { AutocompleteBase } from 'components';

const AutocompleteTenants = ({ setter, settings = null, selected = null }) => {
  settings = settings ?? {};
  settings['@resourceType'] = 'tenant';
  settings.displayLabel = false;
  settings.fullObjects = true;
  settings.multiple = false;

  return (
    <AutocompleteBase setter={setter} settings={settings} selected={selected} />
  );
};

export default AutocompleteTenants;
